export default {
      id: "icon-edit-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "dist/sprite.svg#icon-edit",
      toString: function () {
        return this.url;
      }
    }